<div class="list-variable-item__container">
  <button mat-list-item class="list-variable-item__question" [class.active]="active" (click)="activate.emit(question.id)">
    {{ question.id }}. {{ question.variableToken }}
  </button>
</div>
